import React from 'react';
import { capitalize } from '@insurancemenu/imenu-components-lib/dist/helpers';
import clsx from 'clsx';
import { createStyles } from './styles';

interface AgentInformationProps {
  info: Record<string, string>;
  blockTitle: string;
  className?: string;
}

const ContactBlock = ({ info, blockTitle, className = '' }: AgentInformationProps): JSX.Element => {
  const classes = createStyles();

  const isInfoProvided = Object.values(info).some((value) => value);

  const ContactSections = Object.entries(info).map(([title, value]) => {
    return (
      <React.Fragment key={title}>
        {value ? (
          <div className={classes.infoBlock}>
            <p className={classes.infoKey}>{capitalize(title)}:</p>
            <p className={classes.infoValue}>{value}</p>
          </div>
        ) : (
          <React.Fragment key={title} />
        )}
      </React.Fragment>
    );
  });

  return isInfoProvided ? (
    <div className={clsx(classes.categoryWrapper, className)}>
      <div className={classes.infoWrapper}>
        <h3 className={classes.title}>{blockTitle}</h3>
        {ContactSections}
      </div>
    </div>
  ) : (
    <></>
  );
};

export default ContactBlock;
